import React, { Suspense, lazy } from 'react';

const RichText = lazy(() => import('../../nui/RichText'));

const RichTextWidget = ({ onChange, value, initialValue }) => {
  return (
    <Suspense fallback={null}>
      <RichText
        key={initialValue} // Restart component when initialValue changes.
        value={value}
        onChange={onChange}
      />
    </Suspense>
  );
};

export default RichTextWidget;
